var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, OnChanges } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { ngxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';
import { takeUntil, filter } from 'rxjs/operators';
var HelpMenuComponent = /** @class */ (function () {
    function HelpMenuComponent(store, zendeskService) {
        this.store = store;
        this.zendeskService = zendeskService;
        this.ngUnsubscribe = new Subject();
        this.widgetHorizontalPosition = 'right';
        this.widgetVerticalPosition = 'bottom';
        this.widgetHorizontalOffset = 0;
        this.widgetVerticalOffset = 0;
    }
    HelpMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        // global settings (position, etc...)
        this.updateZendeskWidgetSettings();
        // set settings
        this.zendeskService.setHelpCenterSuggestions({
            labels: ['webhelp']
        });
        // set identity
        this.userProfile$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (profile) {
            if (profile) {
                _this.zendeskService.identify({
                    name: _this.getUserFullName(profile),
                    email: profile.email
                });
                _this.updateZendeskWidgetSettings();
            }
        });
        // set locale
        this.userLocale$
            .pipe(filter(function (userLocale) { return userLocale != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (userLocale) {
            var locale = userLocale.lang;
            _this.zendeskService.setLocale(locale);
        });
    };
    HelpMenuComponent.prototype.ngOnChanges = function () {
        this.updateZendeskWidgetSettings();
    };
    HelpMenuComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    HelpMenuComponent.prototype.handleHelpClicked = function () {
        this.showZendeskWidget();
    };
    HelpMenuComponent.prototype.updateZendeskWidgetSettings = function () {
        var profile = this.store.selectSnapshot(AuthState.getUserProfile);
        // generate custom user tags
        var userTags = [];
        if (profile) {
            var premium_account = profile.premium_account, premium_account_type = profile.premium_account_type, developer_account = profile.developer_account, subscription = profile.subscription;
            // permium user
            if (premium_account) {
                userTags.push("premium_account_" + premium_account_type);
                // subscription type
                if (subscription) {
                    userTags.push("subscription_" + subscription.subscription_provider);
                }
            }
            else {
                userTags.push('free_account');
            }
            // developer
            if (developer_account) {
                userTags.push('developer_account');
            }
        }
        this.zendeskService.setSettings({
            // widget placement
            webWidget: {
                position: {
                    horizontal: this.widgetHorizontalPosition,
                    vertical: this.widgetVerticalPosition
                },
                offset: {
                    horizontal: this.widgetHorizontalOffset + "px",
                    vertical: this.widgetVerticalOffset + "px"
                },
                contactForm: {
                    tags: userTags,
                    fields: [
                        { id: 'name', prefill: { '*': this.getUserFullName(profile) } }
                    ]
                }
            }
        });
    };
    HelpMenuComponent.prototype.showZendeskWidget = function () {
        this.zendeskService.activate({
            hideOnClose: true
        });
    };
    HelpMenuComponent.prototype.hideZendeskWidget = function () {
        this.zendeskService.hide();
    };
    HelpMenuComponent.prototype.getUserFullName = function (profile) {
        if (profile) {
            var first_name = profile.first_name, last_name = profile.last_name;
            return first_name + " " + last_name;
        }
        else {
            return '';
        }
    };
    __decorate([
        Select(AuthState.getUserProfile),
        __metadata("design:type", Observable)
    ], HelpMenuComponent.prototype, "userProfile$", void 0);
    __decorate([
        Select(AuthState.getUserLocale),
        __metadata("design:type", Observable)
    ], HelpMenuComponent.prototype, "userLocale$", void 0);
    return HelpMenuComponent;
}());
export { HelpMenuComponent };
